// EXTERNAL
import { useHistory } from "react-router-dom";
import { useState } from "react";

// CSS
import "./FrontPage.css"

// COMPONENTS
import BigPrimaryButton from "../components/BigPrimaryButton.js"
import LabelledInputBox from "../components/LabelledInputBox.js"
import BrandingPanel from "../components/BrandingPanel.js";
import SubmitButton from "../components/SubmitButton.js"
import InfoBox from "../components/InfoBox.js"

/** 
 * This component renders the password reset page.
 * 
 * @returns {ReactElement} A React element that renders the password reset page. 
 */
export default function PasswordResetPage({}) {
  const history = useHistory();
  const pathSegments = window.location.pathname.split('/');
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [password, setPassword] = useState("");
  const [repassword, setRepassword] = useState("");

  const validatePassword = () => {
    if (password.length < 8) {
        setPopupMessage("Password must be at least 8 characters.");
        setShowPopup(true);
    } else if (/^\d+$/.test(password)) {
        setPopupMessage("Password cannot be entirely numeric.");
        setShowPopup(true);
    } else if (password !== repassword && repassword.length > 0) {
        setPopupMessage("Password fields must match.");
        setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  };

  const handleResetPasswordRequest = async (e) => {
    const userData = document.forms["Reset Password"].elements;

    const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/users/reset_password/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
          email: userData["Email"].value,
        }),
    })

    if (response.status == 204) {
      history.push("/login?reason=reset-password-request")
    } else {
      const errorData = await response.json();
      setPopupMessage(Object.values(errorData)[0]);
      setShowPopup(true);
    }
  }

  const handleResetPassword = async (e) => {
    const userData = document.forms["Log In"].elements;

    const response = await fetch(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/users/reset_password_confirm/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(
        {
          uid: pathSegments[2],
          token: pathSegments[3],
          new_password: userData["New Password"].value,
          re_new_password: userData["Confirm New Password"].value,
        }),
    })
    
    if (response.status === 204) {
      history.push("/login?reason=reset-password");
    } else {
      const errorData = await response.json();
      setPopupMessage(Object.values(errorData)[0].join("\n"));
      setShowPopup(true);
    }
  }

  return (
    <div className="front-page-body">
      <BrandingPanel></BrandingPanel>
      <div className="front-page-content">
        <InfoBox boxStyle="default" isVisible={showPopup} onClose={() => setShowPopup(false)}>{popupMessage}</InfoBox>
        { pathSegments.length == 2 ?
          <form className="front-page-form" name="Reset Password" action={handleResetPasswordRequest}>
              <h2>Enter Email to Reset Password</h2>
              <div className="front-page-vertical-labelled-input-boxes">
                <LabelledInputBox label="Email" type="email" placeholder="Email" required={true}></LabelledInputBox>
              </div>
              <div className="front-page-button-group">
                <SubmitButton buttonStyle="secondary">Reset Password</SubmitButton>
                <BigPrimaryButton buttonStyle="secondary" onClick={() => history.push("/login")}>Back to Log In</BigPrimaryButton>
              </div>
              <div className="front-page-form-divider"></div>
              <div className="front-page-form-switch">
                <b>Don't have an account?</b>
                <BigPrimaryButton buttonStyle="secondary" onClick={() => history.push("/signup")}>Sign Up</BigPrimaryButton>
              </div>
            </form> :
            <form className="front-page-form" name="Log In" action={handleResetPassword}>
              <h2>Reset Password</h2>
              <div className="front-page-vertical-labelled-input-boxes">
                <LabelledInputBox label="New Password" type="password" placeholder="New Password" required={true} onChange={(e) => setPassword(e.target.value)} onBlur={validatePassword}></LabelledInputBox>
                <LabelledInputBox label="Confirm New Password" type="password" placeholder="Confirm New Password" required={true} onChange={(e) => setRepassword(e.target.value)} onBlur={validatePassword}></LabelledInputBox>
              </div>
              <div className="front-page-button-group">
                <SubmitButton buttonStyle="secondary">Submit</SubmitButton>
              </div>
            </form>
          }
        <div className="copyright">{`© Korotu Technology ${process.env.REACT_APP_COPYRIGHT_YEAR}`}</div>
      </div>
    </div>
  )
}